// =============================================================================
// ゲーム内時間・昼夜サイクル・日数。純粋なロジック（描画には影響しない＝海は無改変）。
// =============================================================================
export const clock = {
  t: 0.42 * 600,     // 当日の経過秒。初期=午前10時ごろ(昼スタート。0だと深夜開始になる)
  day: 1,            // 何日目か（=生存日数）
  dayLength: 600,    // 1日=600秒(10分)
};

export function tickTime(dt: number): void {
  clock.t += dt;
  while (clock.t >= clock.dayLength) { clock.t -= clock.dayLength; clock.day++; }
}

// 0..1（0=深夜0時, 0.25=6時, 0.5=正午, 0.75=18時）
export function timeOfDay(): number { return clock.t / clock.dayLength; }

export function clockLabel(): string {
  const mins = Math.floor(timeOfDay() * 24 * 60);
  const hh = String(Math.floor(mins / 60)).padStart(2, '0');
  const mm = String(mins % 60).padStart(2, '0');
  return `${hh}:${mm}`;
}

// 時間帯（アイコン付き）
export function phaseLabel(): string {
  const tod = timeOfDay();
  if (tod < 0.22) return '🌙 夜';
  if (tod < 0.30) return '🌅 朝';
  if (tod < 0.72) return '☀️ 昼';
  if (tod < 0.80) return '🌇 夕';
  return '🌙 夜';
}
